
/* styles */
require("!!./../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!vue-style-loader!css-loader?sourceMap!./../../node_modules/vue-loader/lib/style-rewriter?id=data-v-4142adf5!./../../node_modules/vue-loader/lib/selector?type=styles&index=0!./../../node_modules/eslint-loader/index.js!./ArticleUsername.vue")

var Component = require("/Users/joshuaking/www/ralph/ralph_pr/node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./../../node_modules/vue-loader/lib/selector?type=script&index=0!./../../node_modules/eslint-loader/index.js!./ArticleUsername.vue"),
  /* template */
  require("!!./../../node_modules/vue-loader/lib/template-compiler?id=data-v-4142adf5!./../../node_modules/vue-loader/lib/selector?type=template&index=0!./../../node_modules/eslint-loader/index.js!./ArticleUsername.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/ArticleUsername.vue
// module id = 22
// module chunks = 1